function nspccValidateFormInputContent($inputValue, $inputElement = null) {
  const returnValue = {
    error: false,
    error_message: "",
    return_value: $inputValue,
  };

  if ($inputElement.getAttribute("required") !== null) {
    if ($inputElement.value == "") {
      returnValue.error = true;
      let inputName = $inputElement
        .getAttribute("name")
        .replace("nspcc_properties[", "")
        .replace("]", "");
      
      // Check if inputName starts with a vowel sound
      const startsWithVowel = /^[aeiou]/i.test(inputName);
      const article = startsWithVowel ? "an" : "a";
      returnValue.error_message = `Please enter ${article} ${inputName}.`;
    }
  }

  if (/\p{Extended_Pictographic}/u.test($inputValue)) {
    returnValue.error = true;
    returnValue.error_message = "Please remove any emojis.";
  }

  return returnValue;
}

document.addEventListener("DOMContentLoaded", function () {
  const allSelectors = {
    addToCartButtons: document.querySelectorAll(
      ".product-add-multi [data-add-multi]"
    ),
    mainProductId: document.querySelector('[name="id"]'),
    addonProductsContainer: document.querySelectorAll(
      ".addon-products-container"
    ),
    additionalProducts: document.querySelectorAll("[data-addon-product]"),
    allFields: document.querySelectorAll('[name^="nspcc_properties"]'),
    addonButtons: document.querySelectorAll("[data-addon-product-button]"),
    errorContainer: document.querySelectorAll(".error-container"),
    priceContainers: document.querySelectorAll(".product-price.multi"),
    addonProductSelects: document.querySelectorAll(".addon-products-select"), // Selector for addon product selects
    clearFieldsButtons: document.querySelectorAll(".nspcc-cf-clear-fields"),
  };



    function updateAddonSelections() {
      allSelectors.addonProductSelects.forEach(function(select) {
        const container = select.closest('.addon-products-container');
        if (container) {
          const currentValue = select.value;
          const buttons = container.querySelectorAll('[data-addon-product-button]');
          buttons.forEach(function(btn) {
            if (btn.getAttribute('data-value') === currentValue) {
              btn.classList.add('selected');
            } else {
              btn.classList.remove('selected');
            }
          });
        }
      });
    }
  
    // Initial call
    updateAddonSelections();
  

    window.addEventListener('pageshow', (event) => {
      // The persisted property is true if the page is being loaded from cache (back/forward navigation)
      if (event.persisted) {
        // clear allFields if they are not empty (except for select fields)
        allSelectors.allFields.forEach(function(field) {
          if (field.tagName !== 'SELECT') {
            field.value = '';
          }
        });
        updateAddonSelections();
        allSelectors.mainProductId.dispatchEvent(new Event('multiVariantUpdate'));
      }
    });

    // Trigger initial price update
    allSelectors.mainProductId.dispatchEvent(new Event('multiVariantUpdate'));
  

  allSelectors.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = format || Shopify.nspcc_money_format;
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };

  allSelectors.mainProductId.addEventListener(
    "multiVariantUpdate",
    function (e) {
      let totalPrice = 0;

      if (allSelectors.mainProductId.getAttribute("data-price")) {
        totalPrice += parseFloat(
          allSelectors.mainProductId.getAttribute("data-price")
        );
      }
      if (allSelectors.mainProductId.querySelectorAll("option").length > 0) {
        allSelectors.mainProductId
          .querySelectorAll("option")
          .forEach((mp_opt) => {
            if (
              mp_opt.getAttribute("selected") &&
              mp_opt.getAttribute("data-price")
            ) {
              totalPrice += parseFloat(mp_opt.getAttribute("data-price"));
            }
          });
      }

      allSelectors.addonButtons.forEach((ap) => {
        if (ap.classList.contains("selected")) {
          if (ap.getAttribute("data-price")) {
            totalPrice += parseFloat(ap.getAttribute("data-price"));
          }
        }
      });
      allSelectors.priceContainers.forEach((pc) => {
        pc.innerHTML = allSelectors.formatMoney(totalPrice);
      });
    }
  );

  allSelectors.addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function (evt) {
      evt.preventDefault();
      const qty = 1;
      const items = [];
      /* main product */
      let mainProduct = {
        id: allSelectors.mainProductId.value,
        quantity: qty,
      };
      let properties = {};
      let cart_attributes = {};
      if (allSelectors.allFields.length > 0) {
        var hasValidationError = false;
        allSelectors.allFields.forEach(function (field) {
          const fieldID = field
            .getAttribute("name")
            .replace("nspcc_properties[", "")
            .replace("]", "");
          const fieldValidation = nspccValidateFormInputContent(
            field.value,
            field
          );
          if (fieldValidation.error == true) {
            /** Show error somewhere */
            allSelectors.errorContainer.forEach(function (ec) {
              ec.dispatchEvent(
                new CustomEvent("showError", {
                  bubbles: true,
                  cancelable: true,
                  detail: fieldValidation,
                })
              );
            });
            hasValidationError = true;
            return false;
          }
          const fieldVal = field.value;
          /** Validate field value */
          properties[fieldID] = fieldVal;
          /*cart_attributes[fieldID + "_" + allSelectors.mainProductId.value] = fieldVal;*/
        });
        if (hasValidationError == true) {
          return false;
        }
        mainProduct.properties = properties;
      }
      items.push(mainProduct);
      /* additional products */
      allSelectors.additionalProducts.forEach(function (additionalProduct) {
        if (additionalProduct.value == "") {
          return;
        }
        const variantID = additionalProduct.value;
        items.push({
          id: variantID,
          quantity: 1,
        });
      });

      const order_object = {
        items: items,
      };

      /*if (Object.keys(cart_attributes).length > 0) {
                    order_object.attributes = cart_attributes;
                }*/

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(order_object),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart:", data);
          
          // Filter to find main product vs addon products
          const mainProduct = data.items.find(item => item.variant_id.toString() === allSelectors.mainProductId.value);
          const addonProducts = data.items.filter(item => item.variant_id.toString() !== allSelectors.mainProductId.value);

          // Calculate total revenue from addon products
          const addonRevenue = addonProducts.reduce((total, item) => {
            return total + (item.price * item.quantity);
          }, 0);

          /** Need to get the original donation value if present */
          window['optimizely'] = window['optimizely'] || [];
          window['optimizely'].push({
            type: "event",
            eventName: "spring_surprise_donation_",
            tags: {
              revenue: addonRevenue,
              value: addonRevenue / 100
            }
          });

          window.location = "/cart";
          // Optionally, update the cart UI here
        })
        .catch((error) => {
          console.error(
            "Error adding product to cart:",
            error
          ); /** Need a front end log */
        });
    });
  });

  /** Get first add to cart button and add event listener to parent form action="/cart/add" - when submit disable default behaviour and trigger a click on add to cart button */
  const addToCartButtonFirst = allSelectors.addToCartButtons[0];
  if (addToCartButtonFirst) {
    const parentForm = addToCartButtonFirst.closest('form');
    if (parentForm) {
      parentForm.addEventListener('submit', function(event) {
        // Cross-browser way to check submission source
        event.preventDefault();
        const submitter = event.submitter || document.activeElement;
        
        // Prevent submission from text inputs
        if (!submitter || 
            submitter.tagName === 'INPUT' && submitter.type === 'text') {
          event.preventDefault();
          return;
        }
        
        // If we got here, it was triggered by a button
        event.preventDefault();
        addToCartButtonFirst.click();
      });
    }
  }
  /* New Functionality: Handle Addon Product Button Clicks */
  allSelectors.addonButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default button behavior if necessary

      // Retrieve the data-value attribute from the clicked button
      const dataValue = button.getAttribute("data-value"); // This could be an empty string

      // Find the nearest addon-products-select <select> element
      // Assuming the button is inside a container that also contains the select
      const addonSelect = button
        .closest(".addon-products-container")
        ?.querySelector(".addon-products-select");

      if (!addonSelect) {
        console.error("Nearest addon-products-select element not found.");
        return;
      }

      // Check if the select contains an option with the desired value
      // If dataValue is null, undefined, or empty string, treat it as empty
      const targetValue = dataValue !== null ? dataValue : "";

      const optionExists = Array.from(addonSelect.options).some(
        (option) => option.value === targetValue
      );
      if (!optionExists) {
        console.error(
          `Option with value "${targetValue}" not found in the select.`
        );
        return;
      }

      // Set the select's value to the data-value (could be empty string)
      addonSelect.value = targetValue;

      // Optionally, trigger a change event if there are listeners that depend on it
      const changeEvent = new Event("change", { bubbles: true });
      addonSelect.dispatchEvent(changeEvent);

      /* New Functionality: Manage 'selected' Class on Buttons */

      // Find all addon buttons within the same container
      const container = button.closest(".addon-products-container");
      if (container) {
        const allButtons = container.querySelectorAll(
          "[data-addon-product-button]"
        );
        allButtons.forEach(function (btn) {
          btn.classList.remove("selected"); // Remove 'selected' class from all buttons
        });
        button.classList.add("selected");

        /** not sure if this works but should also effect when variantChange happens on main-id */

        allSelectors.mainProductId.dispatchEvent(
          new Event("multiVariantUpdate")
        );
      }
    });
  });

  /** Handle input previews */
  if (typeof Handlebars !== "undefined") {
    const customisable_product_preview_selectors = {
      previewContainer: document.querySelectorAll(
        ".customisable-product-preview"
      ),
      previewHBScript: 'script[type="text/template-x-handlebars"]',
      previewContentContainer: ".cpp-preview-container .cpp-p-content",
    };

    customisable_product_preview_selectors.previewContainer.forEach(function (
      cpps
    ) {
      if (cpps.getAttribute("preview-init") === "true") {
        return false;
      }

      /** Set preview */
      if (
        typeof cpps.querySelector(
          customisable_product_preview_selectors.previewHBScript
        ) !== "undefined"
      ) {
        let scriptContent = cpps.querySelector(
          customisable_product_preview_selectors.previewHBScript
        ).innerHTML;
        scriptContent = scriptContent
          .replaceAll("[[", "{{")
          .replaceAll("]]", "}}");
        console.log(scriptContent);
        let compiledTemplate = Handlebars.compile(scriptContent);
        cpps.compiledTemplate = compiledTemplate;
      }
      cpps.addEventListener("fieldChange", function (event) {
        let properties = {};
        allSelectors.allFields.forEach(function (field) {
          const fieldID = field
            .getAttribute("name")
            .replace("nspcc_properties[", "")
            .replace("]", "");
          const fieldVal = field.value;
          properties[fieldID] = fieldVal;
        });
        const templateContent = cpps.compiledTemplate(properties);
        let contentPreviewContainer = cpps.querySelector(
          customisable_product_preview_selectors.previewContentContainer
        );
        contentPreviewContainer.innerHTML = templateContent;
      });
      cpps.setAttribute("preview-init", true);
      cpps.dispatchEvent(new Event("fieldChange"));
    });

    allSelectors.allFields.forEach(function (p_field) {
      if (p_field.getAttribute("fieldChangeListener") === "true") {
        return false;
      }
      p_field.addEventListener("input", function (event) {
        customisable_product_preview_selectors.previewContainer.forEach(
          function (cpps) {
            cpps.dispatchEvent(new Event("fieldChange"));
          }
        );
      });
      p_field.setAttribute("fieldChangeListener", true);
    });
  }

  /** Handle Errors */

  allSelectors.errorContainer.forEach(function (ec) {
    if (ec.getAttribute("ec-init") === null) {
      ec.addEventListener("showError", function (evt) {
        evt.target.classList.add("active");
        evt.target.innerHTML = evt.detail.error_message;

        window.scrollTo({
          top: evt.target.offsetTop,
          behavior: "smooth",
        });
      });
      ec.setAttribute("ec-init", true);
    }
  });

  /* Function to programmatically select an addon */
  function nspccSelectAddon(container, value) {
    const select = container.querySelector('.addon-products-select');
    const button = container.querySelector(`.ao-${value}`);
    
    if (select && button) {
      // Update select value
      select.value = value;
      
      // Update button states
      const allButtons = container.querySelectorAll('[data-addon-product-button]');
      allButtons.forEach(btn => btn.classList.remove('selected'));
      button.classList.add('selected');
      
      // Trigger price update
      allSelectors.mainProductId.dispatchEvent(new Event('multiVariantUpdate'));
    }
  }

  /* Make function available globally */
  window.nspccSelectAddon = nspccSelectAddon;

  /* Handle Clear Fields functionality */
  allSelectors.clearFieldsButtons.forEach(function(clearButton) {
    // Add accessibility attributes
    clearButton.setAttribute('role', 'button');
    clearButton.setAttribute('tabindex', '0');
    clearButton.setAttribute('aria-label', 'Clear all fields');
    
    // Initially hide the clear button
    clearButton.classList.add('hidden');
    
    // Get field names from data attribute
    const fieldNames = clearButton.getAttribute('data-field-names');
    if (!fieldNames) return;
    
    const fieldsToWatch = fieldNames.split(',').map(name => name.trim());
    
    // Function to check if any fields have value
    function checkFieldsHaveValue() {
      const inputs = fieldsToWatch.map(fieldName => 
        Array.from(document.querySelectorAll(`[name="nspcc_properties[${fieldName}]"]`))
      ).flat();
      
      // Show button if any text input has value
      const hasValue = inputs.some(input => {
        const isValid = input && 
                       input.tagName !== 'SELECT' && 
                       typeof input.value !== 'undefined' && 
                       input.value.trim() !== '';
        
        return isValid;
      });
      
      if (hasValue) {
        clearButton.classList.remove('hidden');
        clearButton.setAttribute('aria-hidden', 'false');
      } else {
        clearButton.classList.add('hidden');
        clearButton.setAttribute('aria-hidden', 'true');
      }
    }
    
    // Function to handle clearing fields
    function handleClear(e) {
      // If an event was passed, prevent default behavior
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      
      fieldsToWatch.forEach(fieldName => {
        const inputs = document.querySelectorAll(`[name="nspcc_properties[${fieldName}]"]`);
        inputs.forEach(input => {
          if (input.tagName === 'SELECT') {
            input.selectedIndex = 0;
            input.dispatchEvent(new Event('change'));
          } else {
            input.value = '';
            input.dispatchEvent(new Event('input'));
          }
        });
      });

      // Trigger preview update if exists
      if (typeof customisable_product_preview_selectors !== 'undefined') {
        customisable_product_preview_selectors.previewContainer.forEach(function(cpps) {
          cpps.dispatchEvent(new Event('fieldChange'));
        });
      }

      // Clear any error messages
      allSelectors.errorContainer.forEach(function(ec) {
        ec.classList.remove('active');
        ec.innerHTML = '';
      });
      
      // Hide clear button after clearing
      clearButton.classList.add('hidden');
      clearButton.setAttribute('aria-hidden', 'true');
    }

    // Watch for input changes on the fields
    fieldsToWatch.forEach(fieldName => {
      const inputs = document.querySelectorAll(`[name="nspcc_properties[${fieldName}]"]`);
      inputs.forEach(input => {
        input.addEventListener('input', checkFieldsHaveValue);
      });
    });
    
    // Initial check with small delay to ensure fields are populated
    setTimeout(checkFieldsHaveValue, 100);
    
    // Add click and keyboard event listeners
    clearButton.addEventListener('click', handleClear);
    clearButton.addEventListener('keydown', function(e) {
      // Handle Enter or Space key
      if (e.key === 'Enter' || e.key === ' ') {
        handleClear(e);
      }
    });
  });

  if( allSelectors.addToCartButtons.length <= 0 ){
    /** No add to cart button found - remove nspcc_ from nspcc_properties in name attribute */
    allSelectors.allFields.forEach(function(field) {
      field.setAttribute('name', field.getAttribute('name').replace('nspcc_properties', 'properties'));
      field.setAttribute('nspcc-property', true);
    });
  }

 /** Handle date picker
  * Create a timestamp for the date picked and add it to the hidden input whenever the date picker changes
  * */ 
 function updateDatePickerValue( field ) {
    const datePicker = field.closest('.nspcc-date-picker');
    if(datePicker) {
      /** Make field value a timestamp */
      const datePickerValue = new Date(field.value).getTime();
      const hiddenInput = datePicker.querySelector('input[type="hidden"]');
      if(hiddenInput) {
        hiddenInput.value = datePickerValue;
      } 
    }
 }
  allSelectors.allFields.forEach(function(field) {
    if( field.getAttribute('type') === 'date' && field.getAttribute('data-date-picker') === 'true') {
      field.addEventListener('change', function() {
        updateDatePickerValue(field);
      });
      updateDatePickerValue(field);
    }
  });

});




